module.exports = __webpack_public_path__ + "static/media/c9.c4b27ec7.jpg";